var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgGear(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 17,
    height: 18,
    viewBox: "0 0 17 18",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#313D48",
    fillRule: "evenodd",
    d: "M15.088 10.12c.033-.268.058-.534.058-.818 0-.283-.025-.55-.058-.816l1.758-1.375a.42.42 0 0 0 .1-.534L15.28 3.694c-.1-.183-.325-.25-.509-.183l-2.075.833a6.088 6.088 0 0 0-1.408-.817l-.317-2.208a.406.406 0 0 0-.408-.35H7.23a.406.406 0 0 0-.409.35l-.316 2.208a6.402 6.402 0 0 0-1.409.817l-2.075-.833a.406.406 0 0 0-.508.183L.846 6.577a.41.41 0 0 0 .1.534l1.759 1.375a6.61 6.61 0 0 0-.059.816c0 .275.025.55.059.817L.946 11.494a.42.42 0 0 0-.1.533l1.667 2.884c.1.183.325.25.508.183l2.075-.833c.434.333.9.608 1.409.816l.316 2.209c.025.2.2.35.409.35h3.333c.208 0 .383-.15.408-.35l.317-2.209a6.402 6.402 0 0 0 1.408-.816l2.075.833c.192.075.409 0 .509-.183l1.666-2.884a.42.42 0 0 0-.1-.533l-1.758-1.375zm-6.192 2.1A2.92 2.92 0 0 1 5.98 9.301a2.92 2.92 0 0 1 2.916-2.916 2.92 2.92 0 0 1 2.917 2.916 2.92 2.92 0 0 1-2.917 2.917z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGear);
export default __webpack_public_path__ + "static/media/gear.bf967698100458145b7923fda96704cd.svg";
export { ForwardRef as ReactComponent };